


































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { uniqueId } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  BODY_HEIGHT,
  Col,
  DataTableHeader
} from '@/components/molecules/DataTable'
import { RecycleScroller } from '@/components/molecules/RecycleScroller'

export interface AuthorityAuthorTableItem {
  isSelected: boolean
  display: string
  displayKana: string
  specialty: string
  yearOfBirth: string
  work: string
  tag: string
  authorityNo: string
}

export const defaultAuthorityAuthorTableItem = (): AuthorityAuthorTableItem => ({
  isSelected: false,
  display: '',
  displayKana: '',
  specialty: '',
  yearOfBirth: '',
  work: '',
  tag: '',
  authorityNo: ''
})

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'display',
        headerText: '表記'
      }
    ]
  },
  {
    width: '20',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'displayKana',
        headerText: 'カナ'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'specialty',
        headerText: '専門・世系等'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'yearOfBirth',
        headerText: '生没年'
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'work',
        headerText: '職業・専門等'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'authorityId',
        headerText: '典拠ＩＤ'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'authorityNo',
        headerText: '管理番号'
      }
    ]
  }
]

@Component({
  components: {
    DataTable,
    DataTableHeader,
    RecycleScroller
  }
})
export default class AuthorityAuthorTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: AuthorityAuthorTableItem[]

  @Prop({
    type: Number,
    default: BODY_HEIGHT
  })
  height!: number

  get radioName(): string {
    return uniqueId('authority-author-table')
  }

  get showCols(): Col[] {
    return COLS
  }

  @Emit('select:item')
  onClickTableRow(index: number): number {
    return index
  }
}
